import { render, staticRenderFns } from "./Queues.vue?vue&type=template&id=02d5c473&"
import script from "./Queues.vue?vue&type=script&lang=js&"
export * from "./Queues.vue?vue&type=script&lang=js&"
import style0 from "./Queues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports